<template>
    <div>
        <el-card class="calendarContent">
            <div slot="header" class="calendarHeader">
                <el-button :type="isSelect?'':'primary'" @click="allScheduling">全部巡检</el-button>
                <el-button :type="isSelect?'primary':''" @click="myScheduling">我的巡检</el-button>
                <span class="grey"></span><span class="headerText">非本月巡检待办</span>
                <span class="lightblue"></span><span class="headerText">本月巡检代办</span>
                <span class="headerTip">点击待办即可查看具体巡检时间</span>
            </div>
            <div class="floatContent" id="floatContent">
                <div class="floatText">
                    <p>{{title}}</p>
                    <p>{{startTime}}</p>
                    <div class="floatArrow"></div>
                </div>

            </div>

            <div class="calendarBox"   @mouseover="hhh">
                <full-calendar :events="monthData" class="test-fc"
                               first-day='1' lang="zh"
                               @changeMonth="changeMonth"
                               @eventClick="eventClick"


                >

                </full-calendar>
            </div>
        </el-card>
    </div>
</template>

<script>

    import services from './inspection.service.js';
    import { FullCalendar } from 'vue-fullcalendar';
    export default {
        data: function () {
            return {
                monthData: [],//渲染的日历数据
                sendData:{//请求日历的参数
                    queryOptions:1,
                    monthDate:'',
                },
                keepMonth:undefined,//切换月份的时候记录当前月份
                isSelect:true,//是否选中我的排班
                title:'',
                startTime:'',
                timer:null,
                oFloat:null,
            }
        },
        mounted(){
            this.sendData.monthDate = this.getData();
            this.oFloat=document.getElementById('floatContent')
            // this.getList();
        },
        methods: {
            hhh(e){
                // console.log(e.target);
                if (e.target.className==='event-item is-start') {
                    clearTimeout(this.timer)
                    e.target.onmouseout=null
                }
            },
            getData(){//获取当月第一天日期
                let date = new Date();
                let year = date.getFullYear();
                let month = (date.getMonth()+1) > 9 ? date.getMonth()+1 : '0'+(date.getMonth()+1);
                return year + '-' + month + '-01';
            },
            getList(){//获取数据
                this.monthData = [];
                services.inspectionCalendar(this.sendData).then(res=>{
                    res.forEach(item => {
                        this.monthData.push({title:item.title+'('+item.currentHandler+')',start:item.inspectTime});
                    });
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            // 选择月份
            changeMonth (start, end, current) {
                this.keepMonth = current;//保留切换的月份
                this.sendData.monthDate = current;
                // console.log(current);
                this.getList();
            },
            // 点击事件
            eventClick (event, jsEvent, pos) {
                // console.log(this.timer);
                clearTimeout(this.timer)
                this.oFloat.style.display='none'
                this.oFloat.style.display='block'
                this.title=event.title
                this.startTime=event.start
                // console.log(event);
                // console.log(jsEvent);
                // console.log(pos);
                jsEvent.target.id='hahaha'
                let oBox=document.getElementById('hahaha')
                // console.log(oBox);
                let Parent=oBox.offsetParent.offsetParent.offsetParent
                // console.log(Parent);
                // console.log(Parent.clientHeight);
                let height=Parent.clientHeight
                let left=this._offsetLeft(oBox,Parent)
                let top=this._offsetTop(oBox,Parent)
                let bottom=height-top
                // console.log(left);
                // console.log(top);
                // console.log(oFloat);
                this.oFloat.style.left=left+'px'
                this.oFloat.style.bottom=bottom+4+'px'
                //给点击元素挂载onmouseout函数
                jsEvent.target.onmouseout=e=> {
                    e.target.id=''
                    // console.log(this);
                    this.timer=setTimeout(()=>{
                        // console.log(this);
                        this.oFloat.style.display='none'
                        // clearTimeout(this.timer)
                    },1000)

                }
            },
            //获取点击元素相对于日历el-card的left偏移量
            _offsetLeft(cur,par){
                // console.log(cur);
                // console.log(par);
                let oParent = cur.offsetParent;
                    if (oParent === par){
                        return cur.offsetLeft
                    } else{
                        return cur.offsetLeft + oParent.clientLeft + this._offsetLeft(oParent,par)
                    }
            },
            //获取点击元素相对于日历el-card的top偏移量
            _offsetTop(cur,par){
                // console.log(cur);
                // console.log(par);
                let oParent = cur.offsetParent;
                if (oParent === par){
                    return cur.offsetTop
                } else{
                    return cur.offsetTop + oParent.clientTop + this._offsetTop(oParent,par)
                }
            },
            allScheduling(){//全部排班
                this.isSelect = false;
                this.sendData.queryOptions = 2;
                if(this.keepMonth){//判断是否切换过月份
                    this.sendData.monthDate = this.keepMonth;
                }else{
                    this.sendData.monthDate = this.getData();
                }
                this.getList();
            },
            myScheduling(){//我的排班
                this.isSelect = true;
                this.sendData.queryOptions = 1;
                if(this.keepMonth){//判断是否切换过月份
                    this.sendData.monthDate = this.keepMonth;
                }else{
                    this.sendData.monthDate = this.getData();
                }
                this.getList();
            }
        },
        components: {
            'full-calendar': require('vue-fullcalendar'),
        },
    }

</script>

<style scoped>
    .calendarHeader .headerText{
        vertical-align: middle;
        margin-left: 4px;
    }
    .calendarHeader .headerTip{
        vertical-align: middle;
        margin-left: 290px;
        color: grey;
    }
    .calendarHeader .grey{
        display: inline-block;
        width: 40px;
        height: 14px;
        background: grey;
        vertical-align: middle;
        margin-left: 24px;
    }
    .calendarHeader .lightblue{
        display: inline-block;
        width: 40px;
        height: 14px;
        background: lightblue;
        vertical-align: middle;
        margin-left: 30px;
    }

   /deep/.full-calendar-body .dates .dates-events .events-week .events-day .event-box .event-item.is-start{
       background: lightblue !important;
    }
   /deep/.full-calendar-body .dates .dates-events .events-week .events-day .event-box .event-item.is-start:hover{
       background: yellow !important;
   }

    /*非本月的巡检，让他显示灰色*/
   /deep/.full-calendar-body .dates .dates-events .events-week .not-cur-month .event-box .event-item.is-start{
       background: lightgray !important;
       /*display: none;*/
   }
   /deep/.full-calendar-body .dates .dates-events .events-week .not-cur-month .event-box .event-item.is-start:hover{
       background: lightgray !important;
       /*display: none;*/
   }
   .calendarContent{
       position: relative;
   }
    .floatContent{
       position: absolute;
        background: white;
        z-index: 999;
        display: none;
   }
    .floatText{
        display: block;
        width: 150px;
        /*background: green !important;*/
        border: 1px solid grey;
        position: relative;
        box-shadow: 3px 2px 7px #888888;
    }
   .floatText p{
       word-wrap: break-word;
       word-break: break-all;
   }
    .floatArrow{
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 10px 10px 0 10px;
        border-color: grey transparent transparent transparent;
        position: absolute;
        bottom: -10px;
        left: 60px;
    }
    .floatArrow:after{
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        top: -12px;
        left: -10px;
        border-width: 10px 10px 0 10px;
        border-style: solid;
        border-color: white transparent transparent transparent;
    }
</style>
<style rel="stylesheet/scss" lang="scss" scoped>
        .calendarBox{
            /deep/ .comp-full-calendar{
                max-width: 1200px !important;
                /*background: pink;*/
            }
            /deep/ .week{
                height: 40px;
                line-height: 40px;
                font-size: 16px;
            }
            /deep/ .prev-month{
                font-size: 23px;
            }
            /deep/ .title{
                font-size: 18px;
            }
            /deep/ .next-month{
                font-size: 23px;
            }
        }

</style>
